module.exports = __webpack_public_path__ + "static/media/40.df66ee1d.jpg";